import { Center, Spinner, useToast } from "@chakra-ui/react";
import { useMutation } from "@tanstack/react-query";
import { ResStatus } from "lib/api/enum";
import usePathNavigate from "lib/hook/usePathNavigate";
import withAuth from "lib/hook/withAuth";
import queryString from "query-string";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { callOrderRegistApi } from "./api";

const Payment = () => {
    const location = useLocation();
    const { pathNavigate, backNavigate } = usePathNavigate();
    const toast = useToast();
    console.log("Payment");

    const { mutate: orderRegistMutate } = useMutation(callOrderRegistApi, {
        onSuccess: (data) => {
            if (data.status === ResStatus.RES_SUCCESS) {
                localStorage.setItem("ordersheetdata", "");
                const { delivery_method, pickup, order_id } = data.command;
                pathNavigate(
                    `/secure/paymentresult?delivery_method=${delivery_method}&reservation_date=${pickup.reservation_date}&order_id=${order_id}`
                );
            } else {
                backNavigate();
                toast({
                    title: "오류",
                    description: data.result_message,
                    status: "error",
                    duration: 3000,
                    isClosable: true,
                    position: "top",
                });
            }
        },
        onError: (error: any) => {
            console.log("error : ", error);
            backNavigate();
            toast({
                title: "오류",
                description: error.message,
                status: "error",
                duration: 3000,
                isClosable: true,
                position: "top",
            });
        },
    });

    useEffect(() => {
        const query = queryString.parse(location.search);
        console.log("Payment query : ", query);
        const {
            success,
            imp_success,
            merchant_uid,
            imp_uid,
            error_code,
            error_msg,
        } = query as {
            success: string;
            imp_success: string;
            merchant_uid: string;
            imp_uid: string;
            error_code: string;
            error_msg: string;
        };
        if (imp_success === "true" || success === "true") {
            orderRegistMutate({
                merchant_uid: merchant_uid,
                imp_uid: imp_uid!,
            });
        } else {
            console.log("결제실패" + error_msg);
            backNavigate();
        }
    }, []);

    return (
        <Center w="100%" h="100%">
            결제확인중
            <Spinner
                thickness="4px"
                speed="0.65s"
                emptyColor="gray.200"
                color="mint.500"
                size="xl"
            />
        </Center>
    );
};

export default withAuth(Payment);
